import { TiptapEditor } from "@/components/ui/wysiwyg-editor/tiptap-editor";

import { MagazineEditorTips } from "./tips/tips";

import type { ComponentProps } from "react";

type Props = {
	resourceName: string;

	tiptapEditorProps: ComponentProps<typeof TiptapEditor>;
};

/**
 * resourceName が未設定の場合のテキスト（マガジン編集画面用）
 */
const DEFAULT_RESOURCE_NAME_IN_MAGAZINE_EDITOR = "未設定（商品管理の編集画面から商品名を設定してください）";

export const MagazineEditor = ({ resourceName, tiptapEditorProps }: Props) => {
	return (
		<div className="relative min-h-screen w-full bg-white">
			<div className="space-y-8 py-6">
				<div className="flex justify-center px-4 laptop:px-0">
					<div className="flex w-full max-w-4xl items-end justify-start gap-x-3 border-b border-b-zinc-100 pb-6">
						<div className="flex cursor-default items-end gap-x-6">
							<h2 className="text-xl font-bold">
								{resourceName || DEFAULT_RESOURCE_NAME_IN_MAGAZINE_EDITOR}
							</h2>
						</div>

						<MagazineEditorTips />
					</div>
				</div>

				<div className="flex justify-center px-4 laptop:px-0">
					<div className="w-full max-w-4xl overflow-hidden">
						<TiptapEditor {...tiptapEditorProps} />
					</div>
				</div>
			</div>
		</div>
	);
};

MagazineEditor.displayName = "MagazineEditor";
